// extracted by mini-css-extract-plugin
module.exports = {"website-links":"classes_website-links__2Q2_j","link":"classes_link__3faJ1"};